import React from 'react'
import { I18nextProvider, Trans, useTranslation } from '@mc/i18n'
import { TableHeader, useTiersInfo } from '@mc/plans-ui'
import { i18nInstance } from '../../../i18n/i18nInstance'
import { PROMO_I18N_NAMESPACE } from '../../../lib/constants'

// Badges are passed in rather than owned here: the checkout app decides which
// plan carries one, and prcng-1109_v1 badges Plus during a promotion too.
type MatrixHeaderProps = {
  duoBadge?: string
  hideFamilyBadge?: boolean
}

export const MatrixHeader = (props: MatrixHeaderProps) => (
  <I18nextProvider i18n={i18nInstance}>
    <MatrixHeaderWrapped {...props} />
  </I18nextProvider>
)

const MatrixHeaderWrapped = ({
  duoBadge,
  hideFamilyBadge,
}: MatrixHeaderProps) => {
  const { t } = useTranslation(PROMO_I18N_NAMESPACE)
  const { individual, duo, family } = useTiersInfo()

  return (
    <>
      <TableHeader.Titles>
        <TableHeader.IndividualTitle>
          {individual.displayName}
        </TableHeader.IndividualTitle>
        <TableHeader.DuoTitle>{duo.displayName}</TableHeader.DuoTitle>
        <TableHeader.FamilyTitle>{family.displayName}</TableHeader.FamilyTitle>
      </TableHeader.Titles>

      <TableHeader.Actions>
        <TableHeader.IndividualAction
          description={
            <Trans
              ns={PROMO_I18N_NAMESPACE}
              i18nKey='common.plans.headers.one.devicesInfo'
            >
              <br />
            </Trans>
          }
          label={t('common.plans.headers.cta.label', {
            plan: individual.displayName,
          })}
          selectedLabel={t('common.plans.headers.cta.selected')}
          unselectedLabel={t('common.plans.headers.cta.select')}
        />
        <TableHeader.DuoAction
          description={
            <Trans
              ns={PROMO_I18N_NAMESPACE}
              i18nKey='common.plans.headers.two.devicesInfo'
            >
              <br />
            </Trans>
          }
          label={t('common.plans.headers.cta.label', {
            plan: duo.displayName,
          })}
          selectedLabel={t('common.plans.headers.cta.selected')}
          unselectedLabel={t('common.plans.headers.cta.select')}
          badge={duoBadge}
        />
        <TableHeader.FamilyAction
          description={
            <Trans
              ns={PROMO_I18N_NAMESPACE}
              i18nKey='common.plans.headers.three.devicesInfo'
            >
              <br />
            </Trans>
          }
          label={t('common.plans.headers.cta.label', {
            plan: family.displayName,
          })}
          selectedLabel={t('common.plans.headers.cta.selected')}
          unselectedLabel={t('common.plans.headers.cta.select')}
          badge={
            hideFamilyBadge ? undefined : t('common.plans.headers.bestValue')
          }
        />
      </TableHeader.Actions>
    </>
  )
}
